import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CurrentComponent } from './current/current.component';
import { EnhancedComponent } from './enhanced/enhanced.component';
import { ComparisonComponent } from './comparison/comparison.component';
import { OptimizeComponent } from './optimize/optimize.component';

const routes: Routes = [
  /* Direct upon app startup */
  {
    path: '',
    redirectTo: '/current-allocation',
    pathMatch: 'full'
  },
  /* Current Allocation Related */
  {
    path: 'current-allocation',
    component: CurrentComponent
  },
  /* Enhanced Allocation Related */
  {
    path: 'enhanced-allocation',
    component: EnhancedComponent
  },
  /* Allocation Comparison Related */
  {
    path: 'allocation-comparison',
    component: ComparisonComponent
  },
  /* Allocation Comparison Related */
  {
    path: 'optimize',
    component: OptimizeComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
